import { doc, getFirestore, setDoc } from "firebase/firestore";
import { UmrahPaperRequest, UmrahPaperRequestStatus } from "../types/UmrahPaperRequest";

export const updateUmrahPaperRequestStatus = async (umrahPaperRequest: UmrahPaperRequest, status: UmrahPaperRequestStatus) => {
  const db = getFirestore();
  await setDoc(
    doc(db, `Employees/${umrahPaperRequest.idNumber}/UmrahPaperRequests/${umrahPaperRequest.id}`),
    { status },
    { merge: true }
  );
};
